import React from 'react';
import { SharedDialog } from '../SharedDialog';
import { useGlobalError } from './ErrorContext';

/**
 * Global Error Dialog - displays any global errors as a prominent modal dialog.
 * Always mounted so Abyss ModalDialog can transition from closed → open.
 * isAuthError=true  → mode="error"   (red, not dismissible, Re-authenticate button)
 * isAuthError=false → mode="confirm" (yellow warning, dismissible, Dismiss button)
 */
export const GlobalErrorDialog = () => {
  const { error, clearError, handleReauth } = useGlobalError();
  const isOpen = !!error;
  const isAuthError = error?.isAuthError ?? false;
  const isHardTimeout = error?.reason === 'hard-timeout';
  const isExchangeFailure = error?.reason === 'exchange-failure';

  const handleCloseTab = React.useCallback(() => {
    if (isExchangeFailure) {
      window.close();
      return;
    }

    clearError();
    if (isHardTimeout) {
      window.history.replaceState({}, document.title, '/signed-out');
      window.dispatchEvent(new PopStateEvent('popstate'));
      return;
    }
    window.close();
  }, [clearError, isExchangeFailure, isHardTimeout]);

  return (
    <SharedDialog
      isOpen={isOpen}
      onClose={isExchangeFailure ? () => {} : clearError}
      mode={isAuthError ? 'error' : 'confirm'}
      title={error?.title ?? ''}
      description={error?.message}
      ariaLabel={error?.title ?? 'Notification'}
      dismissible={!isAuthError}
      secondaryAction={
        isAuthError && !isExchangeFailure
          ? {
              label: 'Re-authenticate',
              onClick: handleReauth,
            }
          : undefined
      }
      primaryAction={{
        label: isExchangeFailure ? 'Close tab' : 'Dismiss',
        onClick: isAuthError ? handleCloseTab : clearError,
      }}
      initialFocus={isExchangeFailure ? 'primary' : isAuthError ? 'secondary' : 'primary'}
    />
  );
};
